"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        root: {
            padding: '0 24px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            borderRadius: 4,
            position: 'relative',
        },
        search: {
            margin: 0,
            '&:hover': {
                background: "".concat(theme_1.default.colors.primaryLight, "33"),
            },
        },
        select: {
            margin: 0,
            paddingLeft: 26,
            paddingRight: 12,
        },
        noSearch: {
            backgroundColor: 'white',
            '&:hover': {
                boxShadow: theme_1.default.shadows.medium,
            },
        },
        compact: {
            padding: 0,
            boxShadow: theme_1.default.shadows.medium,
        },
        activeHard: {
            background: 'linear-gradient(-180deg, #ff8200 0%, #ff7600 100%)',
        },
        gridContainer: {
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '100%',
            height: '100%',
            padding: '18px 0',
        },
        gridContainerCompact: {
            padding: 12,
        },
        gridContainerSearch: {
            padding: '16px 0 20px',
        },
        topContent: {
            flexBasis: 61,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: 0,
            borderBottom: theme_1.default.divider,
        },
        topContentSearch: {
            flexBasis: 48,
            borderBottom: '0 solid white',
        },
        topContentCompact: {
            flexBasis: 42,
            padding: '0 12px',
            borderBottom: '0 solid white',
        },
        topContentCompactLarge: {
            flexBasis: 44,
            paddingTop: 4,
        },
        title: {
            paddingRight: 4,
            width: '100%',
        },
        middleContent: {
            marginTop: 12,
            padding: 0,
            flex: 1,
        },
        middleContentSearch: {
            marginTop: 0,
            padding: 0,
            flex: 1,
        },
        bottomContent: {
            padding: '0 0 4px 0',
            display: 'flex',
            alignItems: 'flex-end',
        },
        bottomContentCompact: {
            padding: '0 12px',
        },
        bottomContentSearch: {
            padding: '0 0 4px 0',
        },
        bottomContentSelect: {
            padding: '4px 0',
        },
        bottomContentSelectLoading: {
            marginTop: -2,
        },
        attributes: {
            display: 'flex',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        attributesCompact: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        attributesCompactLarge: {
            flexDirection: 'column',
            '& $attribute': {
                paddingBottom: 8,
            },
        },
        attribute: {
            marginRight: 8,
            paddingBottom: 12,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
        },
        attributeSkeleton: {
            marginBottom: 14,
        },
        attributeSkeletonCompact: {
            marginBottom: 12,
        },
        attributeSkeletonSelect: {
            marginBottom: 12,
        },
        lockedIconSearch: {
            marginLeft: 'initial',
        },
        iconMargin: {
            marginRight: 8,
        },
        statusLabel: {
            '&:not(:last-child)': {
                marginRight: 12,
            },
        },
        statusLabelCompactlarge: {
            marginTop: -4,
        },
        iconMarginCompact: {
            marginRight: 4,
        },
        innerLinkIcon: {
            marginLeft: 'auto',
        },
        pending: {
            background: 'white',
            boxShadow: theme_1.default.shadows.medium,
        },
        pendingOpacity: {
            opacity: 0.7,
        },
        infoIcons: {
            marginLeft: 'auto',
            marginBottom: 12,
        },
        notAccessible: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            border: theme_1.default.borders.primary,
            '&:hover': {
                boxShadow: 'none',
            },
        },
        searchNotAccessible: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
        unavailableBase: {
            background: 'transparent',
            boxShadow: 'none',
            opacity: 0.7,
            position: 'relative',
        },
        unavailableSearchBorder: {
            border: theme_1.default.borders.primary,
        },
        actionButton: {
            marginRight: -4,
            zIndex: 1,
        },
        linkOverlay: {
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
        },
    });
});
